if (typeof jcms.map_settings != 'undefined' && $('#map_canvas').length) {
  var map = {
    dom: function() {
      this.$map = $('#map');
      this.$mapCanvas = $('#map_canvas');
      this.$mapBody = $('#map-body');
      this.$mainInfoBoxTemplate = $('#main-infobox-template');
      this.$pinpointIcon = undefined;
    },

    definitions: function() {
      // -- Probably don't want to touch.
      this.instance;
      this.mainInfoBox;
      this.mapCenter;
      this.mapBoundry;
      this.mapZoom;
      this.pinpointHeight = 110;
      this.pinpointWidth = 120;

      this.infoboxOffset = {};

      // -- You can touch.
      this.homeImageFile = 'map_home.png';
      this.mainInfoboxHTML = this.$mainInfoBoxTemplate.html();
      this.mapStyles = [
        {
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": (jcms.map.color_text ? jcms.map.color_text : "#a5a19e")
            }
          ]
        }, {
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        }, {
          "featureType": "administrative.country",
          "elementType": "all",
          "stylers": [
            {
              "visibility": "on"
            }
          ]
        }, {
          "featureType": "administrative.province",
          "elementType": "all",
          "stylers": [
            {
              "visibility": "on"
            }
          ]
        }, {
          "featureType": "administrative.locality",
          "elementType": "all",
          "stylers": [
            {
              "visibility": "on"
            }
          ]
        }, {
          "featureType": "administrative.neighborhood",
          "elementType": "all",
          "stylers": [
            {
              "visibility": (jcms.map.neighborhoods ? "on" : "off")
            }
          ]
        }, {
          "featureType": "administrative.land_parcel",
          "elementType": "all",
          "stylers": [
            {
              "visibility": "on"
            }
          ]
        }, {
          "featureType": "landscape",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": (jcms.map.color_ground ? jcms.map.color_ground : "#f2f0f0")
            }
          ]
        }, {
          "featureType": "landscape.man_made",
          "elementType": "labels",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        }, {
          "featureType": "landscape.natural.terrain",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": (jcms.map.color_terrain ? jcms.map.color_terrain : "#000000")
            }
          ]
        }, {
          "featureType": "poi",
          "elementType": "all",
          "stylers": [
            {
              "visibility": (jcms.map.pois ? "on" : "off")
            }
          ]
        }, {
          "featureType": "poi.park",
          "elementType": "all",
          "stylers": [
            {
              "visibility": (jcms.map.parks ? "on" : "off")
            }
          ]
        }, {
          "featureType": "poi.park",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": (jcms.map.color_park ? jcms.map.color_park : "#bcd1bb")
            }
          ]
        }, {
          "featureType": "road",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": (jcms.map.color_road ? jcms.map.color_road : "#dfdcdb")
            }
          ]
        }, {
          "featureType": "road",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": (jcms.map.color_road_stroke ? jcms.map.color_road_stroke : "#cccccc")
            }
          ]
        }, {
          "featureType": "road.highway",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": (jcms.map.color_highway ? jcms.map.color_highway : (jcms.map.color_road ? jcms.map.color_road : "#dfdcdb"))
            }
          ]
        }, {
          "featureType": "road.highway",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": (jcms.map.color_highway_stroke ? jcms.map.color_highway_stroke : (jcms.map.color_road_stroke ? jcms.map.color_road_stroke : "#c2bebc"))
            }
          ]
        }, {
          "featureType": "water",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": (jcms.map.color_water ? jcms.map.color_water : "#bbcad2")
            }
          ]
        }
      ];
    },

    loadMap: function(event) {
      map.setOptions();
      map.googleMap = google.maps;
      map.fixFont();
      map.instance = new map.googleMap.Map(map.$mapCanvas[0], map.mapOptions);
      map.bindControls();
      window.addEventListener('resize', map.mapResize);

      let iconSize;
      switch (jcms.theme.contact_map_marker_size) {
        case 'small':
          iconSize = 5;
          break;
        case 'medium':
          iconSize = 9;
          break;
        case 'large':
          iconSize = 14;
          break;
      }

      var homeIcon = {
        path: map.googleMap.SymbolPath.CIRCLE,
        fillColor: jcms.theme[jcms.theme.contact_map_marker_color],
        fillOpacity: 1,
        strokeWeight: 0,
        scale: iconSize
      };

      // -- Place Home Marker
      var mainMarker = new map.googleMap.Marker({
        map: map.instance, position: map.latlng, icon: homeIcon
      });

      // -- Build InfoBox & Bind Toggle Controls
      map.mainInfoBox = $.extend(new InfoBox(map.pinpointOptions), {isMain: true});
      map.openMarker(map.mainInfoBox, mainMarker);
      map.bindMarkerOpen(map.mainInfoBox, mainMarker);
      map.mapCenter = map.instance.getCenter();
      map.googleMap.event.addListenerOnce(map.instance, "projection_changed", function() {
        if ($(window).width() > 808) {
          map.offsetCenter(map.mapCenter, 0, -55);
        }
        else {
          map.offsetCenter(map.mapCenter, 0, -30);
        }
      });

      map.googleMap.event.addListenerOnce(map.instance, 'tilesloaded', function() {
        map.$mapCanvas.find('iframe').attr('title', 'Google Map').removeAttr('frameborder');

        if (typeof map.$pinpointIcon == 'undefined') {
          map.$pinpointIcon = $('#map-pinpoint');
        }

        map.setInfoboxOffset();
      });

      map.googleMap.event.addListener(map.instance, 'bounds_changed', function() {
        map.setInfoboxOffset();
      });
    },

    offsetCenter: function(latlng, offsetx, offsety) {
      setTimeout(function() {
        // latlng is the apparent centre-point
        // offsetx is the distance you want that point to move to the right, in pixels
        // offsety is the distance you want that point to move upwards, in pixels
        // offset can be negative
        // offsetx and offsety are both optional
        var scale = Math.pow(2, map.instance.getZoom());
        var worldCoordinateCenter = map.instance.getProjection().fromLatLngToPoint(latlng);
        var pixelOffset = new map.googleMap.Point((offsetx / scale) || 0, (offsety / scale) || 0);
        var worldCoordinateNewCenter = new map.googleMap.Point(worldCoordinateCenter.x - pixelOffset.x, worldCoordinateCenter.y + pixelOffset.y);
        var newCenter = map.instance.getProjection().fromPointToLatLng(worldCoordinateNewCenter);

        map.instance.setCenter(newCenter);
      }, 10);
    },

    mapResize: function() {
      map.mapBoundry = new map.googleMap.LatLngBounds();
      map.mapCenter = map.instance.getCenter();
      map.mapZoom = map.instance.getZoom();

      map.googleMap.event.trigger(map.instance, "resize");
      map.instance.setCenter(map.mapCenter);
    },

    bindMarkerOpen: function(infoBoxObject, markerObject) {
      var self = this;

      this.googleMap.event.addListener(markerObject, 'click', function() {
        self.openWindow.close();
        self.openMarker(infoBoxObject, markerObject);
      });
    },

    openMarker: function(infoBoxObject, markerObject, callback) {
      // -- Close all InfoBoxes except Main
      if (this.openWindow && !this.openWindow.isMain) {
        this.openWindow.close();
      }

      // -- Open new InfoBox
      infoBoxObject.open(this.instance, markerObject);

      setTimeout(() => {
        map.setInfoboxOffset();
      }, 200);

      this.openWindow = infoBoxObject;
    },

    bindControls: function() {
      var self = this;

      // -- Map click closes all windows
      this.googleMap.event.addListener(self.instance, 'click', function() {
        self.mainInfoBox.close();
        if (self.openWindow) {
          self.openWindow.close();
        }
      });
    },

    fixFont: function() {
      var head = document.getElementsByTagName('head')[0];

      // Save the original method
      var insertBefore = head.insertBefore;

      // Replace it!
      head.insertBefore = function(newElement, referenceElement) {
        if (newElement.href && newElement.href.indexOf('://fonts.googleapis.com/css?family=Roboto') > -1) {
          return;
        }
        insertBefore.call(head, newElement, referenceElement);
      };
    },

    setInfoboxOffset: function() {
      let vertOffset = 0;
      switch (jcms.theme.contact_map_marker_size) {
        case 'small':
          vertOffset = 5;
          break;
        case 'medium':
          vertOffset = 9;
          break;
        case 'large':
          vertOffset = 14;
          break;
      }

      if (typeof map.$pinpointIcon != 'undefined') {
        map.pinpointWidth = map.$pinpointIcon.outerWidth() !== 0 ? map.$pinpointIcon.outerWidth() : map.pinpointWidth;
        map.pinpointHeight = map.$pinpointIcon.outerHeight() !== 0 ? map.$pinpointIcon.outerHeight() : map.pinpointHeight;
      }

      map.infoboxOffset = {
        horizontal: -map.pinpointWidth / 2,
        vertical: -map.pinpointHeight - vertOffset
      };

      if ($(window).width() <= jcms.breakpoints.fluid_medium) {
        map.mainInfoBox.setOptions({
          pixelOffset: new map.googleMap.Size(map.infoboxOffset.horizontal, map.infoboxOffset.vertical)
        });
      }
      else if ($(window).width() <= jcms.breakpoints.fluid && $(window).width() > jcms.breakpoints.fluid_medium) {
        map.mainInfoBox.setOptions({
          pixelOffset: new map.googleMap.Size(map.infoboxOffset.horizontal, map.infoboxOffset.vertical)
        });
      }
      else {
        map.mainInfoBox.setOptions({
          pixelOffset: new google.maps.Size(map.infoboxOffset.horizontal, map.infoboxOffset.vertical)
        });
      }
    },

    setOptions: function() {
      this.latlng = new google.maps.LatLng(jcms.map_settings.lat, jcms.map_settings.lng);

      // -- Pinpoint Infobox Options Object
      this.pinpointOptions = {
        content: this.mainInfoboxHTML,
        disableAutoPan: false,
        maxWidth: 0,
        pixelOffset: new google.maps.Size(map.infoboxOffset.horizontal, map.infoboxOffset.vertical),
        zIndex: 9999,
        boxStyle: {},
        boxClass: "map__infobox",
        closeBoxMargin: "-20px 43px 0 0",
        closeBoxURL: "",
        infoBoxClearance: new google.maps.Size(1, 1),
        isHidden: false,
        pane: "floatPane",
        enableEventPropagation: true
      };

      // -- Map Options Object
      this.mapOptions = {
        zoom: jcms.map.map_zoom ? jcms.map.map_zoom : 14,
        minZoom: 5,
        maxZoom: 25,
        gestureHandling: "cooperative",
        center: this.latlng,
        mapTypeId: jcms.map.type_id,
        mapTypeControl: false,
        mapTypeControlOptions: {
          mapTypeIds: jcms.map.type_ids
        },
        disableDefaultUI: true,
        streetViewControl: jcms.map.streetview,
        styles: this.mapStyles
      };
    },

    checkData: function() {
      var self = this;
      // -- Keep on looping until the google maps script is loaded
      var mapLoaded = setInterval(function() {
        self.loopNum++;
        if (typeof InfoBox == 'function' && typeof google === 'object' && typeof google.maps === 'object') {
          clearInterval(mapLoaded);
          map.dom();
          map.definitions();
          map.loadMap();
        }
        else if (self.loopNum >= 10) {
          clearInterval(mapLoaded);
          $('.map__canvas-wrap').remove();
          return false;
        }
      }, 1000);
    },

    init: function() {
      map.checkData();
    }
  };

  $(function() {
    if ($('#map_canvas').length) {
      map.init();
    }
  });
}
